const starsFunctionKeyMap = {
    F1: "IC",
    F2: "RP",
    F3: "SU",
    F4: "TC",
    F5: "HD",
    F6: "DA",
    F7: "F",
    F8: "FMA/TSAS",
    F9: "VP",
    F10: "IP",
    F11: "CA",
    F12: "AR",
    SHIFT_F11: "RD",
    Insert: "SIGN",
    ScrollLock: "IF",
    Pause: "TG",
};
export const STARS_KEYBOARD_TRIANGLE = `\u0100`;
export const MULTIFUNC = "F";
export const starsInputTokenOverrideMap = {
    ...starsFunctionKeyMap,
    ",": STARS_KEYBOARD_TRIANGLE,
};
export class StarsCommandProcessingError extends Error {
    result;
    constructor(result) {
        super();
        this.result = result;
    }
}
export function getStarsCommandElements(tokenArray) {
    const res = structuredClone(tokenArray);
    return res.reduce((acc, cur, i, arr) => {
        if (!cur.token || cur.starsFunction) {
            acc.push(cur);
            return acc;
        }
        const lastElement = acc.at(-1);
        if (!lastElement?.token || arr.at(i - 1)?.token === " " || lastElement?.starsFunction) {
            if (cur?.token !== " ") {
                acc.push(cur);
            }
        }
        else if (cur.token && cur.token !== " " && lastElement.token) {
            lastElement.token += cur.token;
        }
        return acc;
    }, []);
}
export function getStarsFunction(key) {
    // @ts-ignore
    return starsFunctionKeyMap[key];
}
export function starsGenericResponse(extrinsicReadout = "", readout = []) {
    return { extrinsicReadout, readout };
}
export function starsFormatError(readout = []) {
    return { readout, extrinsicReadout: "FORMAT" };
}
export function starsIllegalValueError(readout = []) {
    return { readout, extrinsicReadout: "ILL VALUE" };
}
export function starsIllegalPosError(readout = []) {
    return { readout, extrinsicReadout: "ILL POS" };
}
export function starsIllegalTrackError(readout = []) {
    return { readout, extrinsicReadout: "ILL TRK" };
}
//# sourceMappingURL=starsCommand.js.map